import video from '../assets/DuckSong.mp4';

export default function Video() {
    return (
        <div className="text-3xl font-RedditMono flex flex-wrap">
            <div className="w-full md:w-1/2">
                <div className="relative">
                    <div className="absolute w-full h-full bg-black opacity-75 rounded-lg transform md:translate-x-4 translate-y-4"></div>
                    <div className="relative space-y-10 bg-white p-8 border-4 border-black rounded-lg">
                        <div>The song we all know and love.</div>
                        <video src={video} width="750" height="500" controls></video>
                        <div>$GRAPES is a decentralized meme coin on Base inspired by The Duck Song.</div>
                    </div>

                </div>
            </div>
            
            <div className="mt-20 md:mt-0 px-14 w-full md:w-1/2 space-y-20">
                <div className="relative">
                    <div className="absolute w-full h-full bg-black opacity-75 rounded-lg transform md:translate-x-4 translate-y-4"></div>
                    <div className="relative border-4 bg-white border-black rounded-lg p-8">
                    Contract verified and available on Base Etherscan.
                    </div>
                </div>
                
                <div className="relative">
                    <div className="absolute w-full h-full bg-black opacity-75 rounded-lg transform md:translate-x-4 translate-y-4"></div>
                    <div className="relative border-4 bg-white border-black rounded-lg p-8">
                    10 Billion Supply.
                    </div>
                </div>

                <div className="relative">
                    <div className="absolute w-full h-full bg-black opacity-75 rounded-lg transform md:translate-x-4 translate-y-4"></div>
                    <div className="relative border-4 bg-white border-black rounded-lg p-8">
                    Contact me to build your smart contract and website.
                    </div>
                </div>
            </div>
        </div>
    );
}

